import { render, staticRenderFns } from "./ui-menu.vue?vue&type=template&id=7dddc515&scoped=true"
import script from "./ui-menu.vue?vue&type=script&lang=js"
export * from "./ui-menu.vue?vue&type=script&lang=js"
import style0 from "./ui-menu.vue?vue&type=style&index=0&id=7dddc515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dddc515",
  null
  
)

export default component.exports